import core from '../reducers/core-reducer';
import { configureStore } from '@reduxjs/toolkit';
import clubhouseMessagesSlice from '../clubhouse/slices/messages/messages-slice';
import clubhouseSlice from '../clubhouse/slices/clubhouse/clubhouse-slice';
import currentUserSlice from '../slices/current-user/current-user-slice';
import loggerMiddleware from '../middleware/logger';
import directRoomsSlice from '../direct/slices/rooms/direct-rooms-slice';
import directMembersSlice from '../direct/slices/members/direct-members-slice';
import directMessagesSlice from '../direct/slices/messages/direct-messages-slice';
import pricingSlice from '../slices/pricing/pricing-slice';
import userSummarySlice from '../slices/user-summary/user-summary-slice';
import areYouStillHereSlice from '../are-you-still-here/are-you-still-here-slice/are-you-still-here-slice';
import supportRequestsSlice from '../support-portal/slices/threads/support-threads-slice';
import supportThreadsMessagesSlice from '../support-portal/slices/messages/support-threads-messages-slice';
import supportPortalMembersSlice from '../support-portal/slices/members/support-portal-members-slice';
import dataRequestNotificationsSlice from '../models/DataRequestHub/slices/data-request-notifications.slice';
import notificationFlagsSlice from '../slices/notification-flags/notification-flags.slice';
import timelinesSlice from '../slices/marketplace/timeline/timeline.slice';
import buyersSlice from '../slices/marketplace/buyer/buyer.slice';
import brokersSlice from '../slices/marketplace/broker/broker.slice';
import dataRoomSlice from '../slices/marketplace/data-room/data-room.slice';
import opportunitiesSlice from '../slices/marketplace/opportunity/opportunity.slice';
import ThemeOptionsSlice from '../reducers/ThemeOptionsSlice';
import marketplacePricingSlice from '../slices/marketplace/pricing/marketplace-pricing.slice';
import appConfigsSlice from '../slices/app-configs/app-configs.slice';
import profilesDataSlice from '../slices/profiles-data-slice/profiles-data-slice';
import locationsSlice from '../slices/locations-slice/locations-slice';
import serviceFocusesSlice from '../slices/service-focuses/service-focus.slice';
import engagementConferencesSlice from '../slices/marketplace/meetings/engagement-conferences.slice';

export default function configureReduxStore() {
    const store = configureStore({
        reducer: {
            core,
            ThemeOptions: ThemeOptionsSlice,
            clubhouseMessages: clubhouseMessagesSlice,
            clubhouse: clubhouseSlice,
            currentUser: currentUserSlice,
            directRooms: directRoomsSlice,
            directMembers: directMembersSlice,
            directMessages: directMessagesSlice,
            pricing: pricingSlice,
            userSummary: userSummarySlice,
            supportThreads: supportRequestsSlice,
            supportThreadsMessages: supportThreadsMessagesSlice,
            supportPortalMembers: supportPortalMembersSlice,
            areYouStillHere: areYouStillHereSlice,
            dataRequestsNotifications: dataRequestNotificationsSlice,
            notificationFlags: notificationFlagsSlice,
            timelines: timelinesSlice,
            buyersState: buyersSlice,
            brokersState: brokersSlice,
            dataRoomState: dataRoomSlice,
            opportunities: opportunitiesSlice,
            marketplacePricing: marketplacePricingSlice,
            appConfigs: appConfigsSlice,
            profilesData: profilesDataSlice,
            locationsState: locationsSlice,
            serviceFocusesState: serviceFocusesSlice,
            engagementMeetings: engagementConferencesSlice,
        },
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({ serializableCheck: false }).concat(
                process.env.NODE_ENV === 'development' ? [loggerMiddleware] : []
            ),
        devTools: process.env.NODE_ENV !== 'production',
    });

    return store;
}
